import { sort } from '@ember/object/computed';
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import ENV from 'donor-elf-web/config/environment';

export default Controller.extend({
  sortUsersBy: ['displayName'],
  sortedUsers: sort('model.users', 'sortUsersBy'),
  sortFundGroupsBy: ['name'],
  sortedFundGroups: sort('model.fundGroups', 'sortFundGroupsBy'),

  rootURL: computed(function () {
    return ENV.rootURL;
  }),
});
